import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="page-container">
      {/* Banner Section */}
      <div
        className="hero-banner"
        style={{
          width: "100%",
          height: "50vh",
          background: 'url("/Images/About_Header.webp") center/cover no-repeat',
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          boxShadow: "inset 0 0 0 1000px rgba(0, 0, 0, 0.3)",
        }}
      >
        <h1
          className="hero-title"
          style={{
            fontSize: "3rem",
            fontWeight: "bold",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          Farmology - Enabling Farmers through Technology
        </h1>
        <p
          className="breadcrumb"
          style={{
            fontSize: "1rem",
          }}
        >
          <a
            href="/"
            style={{
              color: "inherit",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Home
          </a>{" "}
          /
          <a
            href="/about"
            style={{
              color: "inherit",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            About Us
          </a>
        </p>
      </div>

      {/* About Section */}
      <div className="content-wrapper">
        <img
          src="/Images/About_Body.webp"
          alt="About Us"
          className="about-image"
        />
        <div className="about-content">
          <h2>About Us</h2>
          {/* subtitle */}
          <p style={{ color: "#218838" }}>
            Empowering Farmers with Technology & Sustainable Practices
          </p>
          <p>
            Farmology is dedicated to helping Indian farmers succeed by
            combining modern technology with traditional farming knowledge. We
            work to build trust and efficiency in agriculture by giving farmers
            the right tools and information to increase their crop yield and
            income.
          </p>
          <p>
            Our expert team ensures that farmers have access to advanced
            technology, easy-to-use digital solutions, and high-quality advisory
            services to make farming more profitable and sustainable.
          </p>
        </div>
      </div>

      {/* Full-width Separator Image */}
      {/* <div className="separator-image" style={{ backgroundImage: 'url("/bannerAbout.jpg")' }}></div> */}

      {/* Vision and Mission Section */}
      <h2 className="section-title">Our Vision & Mission</h2>
      <div className="vision-mission-container">
        <div className="vision-mission-item">
          <h3>Our Vision</h3>
          <p>
            To empower small and medium farmers by providing them with
            technology and insights that help them grow more crops, earn higher
            incomes, and build a self-reliant farming community.
          </p>
        </div>
        <div className="vision-mission-item">
          <h3>Our Mission</h3>
          <p>
            Deliver advanced crop advisory and farming inputs through our mobile
            app. Make farming easier and more profitable with real-time digital
            solutions. Promote sustainable agriculture using eco-friendly
            practices and technology.
          </p>
        </div>
      </div>

      {/* Full-width Separator Image */}
      <div
        className="separator-image"
        style={{ backgroundImage: 'url("/Images/About_Footer.webp")' }}
      ></div>

      {/* Video Gallery Section */}
      <h2 className="section-title">What Farmers Say About Us</h2>
      <div className="video-gallery">
        <iframe
          src="https://www.youtube.com/embed/TduNwHhhRGE?si=uNWakNnAJnY5CYuH"
          title="Testimonial 1"
          className="video-embed"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>

        <iframe
          src="https://www.youtube.com/embed/wZQtTsMfnFA"
          title="Testimonial 2"
          className="video-embed"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>

        <iframe
          src="https://www.youtube.com/embed/wt_mwlHUBhU"
          title="Testimonial 3"
          className="video-embed"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      {/* Partners and Awards Section */}
      {/* <h2 className="section-title">Our Partners and Awards</h2>
      <div className="partners-awards-container">
        <div className="partners">
          <h3>Our Associate Organizations</h3>
          <div className="logos">
            <img src="/logo1.png" alt="Partner 1" />
            <img src="/logo2.png" alt="Partner 2" />
            <img src="/logo3.png" alt="Partner 3" />
          </div>
        </div>
        <div className="awards">
          <h3>Awards and Recognitions</h3>
          <div className="logos">
            <img src="/award1.png" alt="Award 1" />
            <img src="/award2.png" alt="Award 2" />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default AboutUs;

